import { render, staticRenderFns } from "./partner-contract-details-readonly.vue?vue&type=template&id=f58ea26e&scoped=true&lang=pug"
import script from "./partner-contract-details-readonly.vue?vue&type=script&lang=ts"
export * from "./partner-contract-details-readonly.vue?vue&type=script&lang=ts"
import style0 from "./partner-contract-details-readonly.vue?vue&type=style&index=0&id=f58ea26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58ea26e",
  null
  
)

export default component.exports